import { render, staticRenderFns } from "./RightsManagementShow.vue?vue&type=template&id=5c0e402e&scoped=true&"
import script from "./RightsManagementShow.vue?vue&type=script&lang=js&"
export * from "./RightsManagementShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0e402e",
  null
  
)

export default component.exports